import { useTranslation } from "react-i18next";
import { LoadingWrapper } from "@vapor/react-contrib-tax-compliance";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { Box, Stack } from "@vapor/react-material";
import React, { useMemo } from "react";
import SyntaxHighlighter from "react-syntax-highlighter";
import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";
import { GovernmentAgencyType } from "../../../../../core/api/use-get-tax-submission-detail/TaxSubmissionDetailDTO";
import { PdfPreviewer } from "../../../../components/pdf-previewer/PdfPreviewer";

interface TaxSubmissionOutcomePreviewerProps {
    loading: boolean;
    file?: {
        content: Uint8Array;
        type: string;
    };
    governmentAgencyType: GovernmentAgencyType;
}

export const TaxSubmissionOutcomePreviewer: React.FC<
    TaxSubmissionOutcomePreviewerProps
> = ({ loading, governmentAgencyType, file }) => {
    const { t } = useTranslation();

    const isPdfPreview = useMemo(
        () => governmentAgencyType === GovernmentAgencyType.ade,
        [governmentAgencyType],
    );

    return (
        <Stack justifyContent="center" alignItems="center">
            <LoadingWrapper
                loading={loading}
                spinnerProps={{
                    loadingText: t(
                        "components.loading_wrapper.loading_message",
                    ),
                }}
            >
                {file &&
                    (file.type === "application/zip" ? (
                        <Box marginTop="24px">
                            <Typography>
                                {t("components.outcome_previewer.no_preview")}
                            </Typography>
                        </Box>
                    ) : isPdfPreview ? (
                        <PdfPreviewer file={file.content} />
                    ) : (
                        <SyntaxHighlighter language={file.type} style={docco}>
                            {new TextDecoder().decode(file.content)}
                        </SyntaxHighlighter>
                    ))}
            </LoadingWrapper>
        </Stack>
    );
};
